module.exports = __webpack_public_path__ + "static/media/loader-dots.fa28de9c.svg";